import React from 'react'

const AppBar = () => {
  return (
    <nav>
            <div
      id="navDemo"
      className="w3-bar-block w3-white w3-hide w3-hide-large w3-hide-medium w3-large"
    >
      <a href="#" className="w3-bar-item w3-button w3-padding-large">
        Link 1
      </a>
      <a href="#" className="w3-bar-item w3-button w3-padding-large">
        Link 2
      </a>
      <a href="#" className="w3-bar-item w3-button w3-padding-large">
        Link 3
      </a>
      <a href="#" className="w3-bar-item w3-button w3-padding-large">
        Link 4
      </a>
    </div>

    </nav>
  )
}

export default AppBar